import moment from "moment";

export const convertUtcToLocal = (utcTime: any,format:any) => {
    return  moment.utc(utcTime).local().format(format?format:'DD/MM/YYYY HH:mm');
};

// export const convertLocalToUtc = (localTime: any,format:any) => {
//     return  moment.utc(localTime).format(format?format:'YYYY-MM-DDTHH:mm');
// };

export const convertLocalToUtc = (localTime: any, format: any, toFormat: any) => {
    return moment(localTime+" 12:00", format+" HH:mm").utc().format(toFormat ? toFormat : 'YYYY-MM-DD');
};

export const convertUtcToLocalWithSeconds = (utcTime: any,format:any) => {
    return  moment.utc(utcTime).local().format(format?format:'DD/MM/YYYY HH:mm:ss:SSS');
};

// export const convertLocalToUtcWithSeconds = (localTime: any,format:any) => {
//     return  moment.utc(localTime).format(format?format:'YYYY-MM-DDTHH:mm:ss.msZ');
// };

export const convertLocalToUtcWithSeconds = (localTime: any, format: any, toFormat: any) => {
    return moment(localTime, format).utc().format(toFormat ? toFormat : 'YYYY-MM-DD HH:mm:ss.SSS');
  };
